import {searchFiltersPlaces} from '@adv-mt/mt-search-filters'
import {searchSortPlaces} from '@adv-mt/mt-search-sort'

export const SEARCH_AI_TOP_BAR_PLACES = {
  ADS_LIST: 'adsList',
  ADS_LIST_SUBSCRIPTION: 'adsListSubscription',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  PROFESSIONAL_STOCK: 'professionalStock'
}

export const SEARCH_AI_TOP_BAR_SEARCH_SORT_PLACES_DICTIONARY = {
  [SEARCH_AI_TOP_BAR_PLACES.ADS_LIST]: searchSortPlaces.ADS_LIST,
  [SEARCH_AI_TOP_BAR_PLACES.ADS_LIST_SUBSCRIPTION]: searchSortPlaces.ADS_LIST_SUBSCRIPTION,
  [SEARCH_AI_TOP_BAR_PLACES.PROFESSIONAL_STOCK_RENTING]: searchSortPlaces.PROFESSIONAL_STOCK_RENTING,
  [SEARCH_AI_TOP_BAR_PLACES.PROFESSIONAL_STOCK]: searchSortPlaces.PROFESSIONAL_STOCK
}

export const SEARCH_AI_TOP_BAR_SEARCH_FILTERS_PLACES_DICTIONARY = {
  [SEARCH_AI_TOP_BAR_PLACES.ADS_LIST]: searchFiltersPlaces.ADS_LIST,
  [SEARCH_AI_TOP_BAR_PLACES.ADS_LIST_SUBSCRIPTION]: searchFiltersPlaces.SUBSCRIPTION_ADS_LIST,
  [SEARCH_AI_TOP_BAR_PLACES.PROFESSIONAL_STOCK_RENTING]: searchFiltersPlaces.PROFESSIONAL_STOCK_RENTING,
  [SEARCH_AI_TOP_BAR_PLACES.PROFESSIONAL_STOCK]: searchFiltersPlaces.PROFESSIONAL_STOCK
}

export const DEFAULT_SEARCH = ''
